<template>
    <div class="ur-data-grid__header__context" v-if="isCtxOpen" :style="ctxStyle" v-toward-center="preventOverflow" @keydown.stop="()=>{}">
        <!-- [ZONE] 정렬 영역 -->
        <div class="ur-data-grid__header__context__sort" v-if="isSort">
            <div class="ur-data-grid__header__context__sort-row" @click="setSort('A')">
                <ur-icon icon="radio_select" type="picto" primary v-if="isSortAsc"/>
                <ur-icon icon="radio" v-else/>
                <label>{{msgAsc}}</label>
            </div>
            <div class="ur-data-grid__header__context__sort-row" @click="setSort('D')">
                <ur-icon icon="radio_select" type="picto" primary v-if="isSortDes"/>
                <ur-icon icon="radio" v-else/>
                <label>{{msgDes}}</label>
            </div>
        </div>
        <!-- [ETC] 구분선 -->
        <div class="ur-data-grid__context__separator" v-if="isSort && isContext"/>
        <!-- [ZONE] 사용자 정의 영역 -->
        <div class="ur-data-grid__header__context__custom" v-if="isContext">
            <template v-for="(ctx, idx) in customContexts">
                <div class="ur-data-grid__context__separator" :key="'sep-'+idx" v-if="ctx.separator"></div>
                <div class="ur-data-grid__context__item" :key="'item-'+idx"
                        @click="onClickContext(ctx)" v-else>
                    <ur-icon :icon="ctx.icon" v-if="ctx.icon"/>
                    <div class="ur-data_grid__context__item__text" v-ur-tooltip.overflow.empty="ctx.text">{{ctx.text}}</div>
                </div>
            </template>
        </div>
        <!-- [ETC] 구분선 -->
        <div class="ur-data-grid__context__separator" v-if="(isSort || isContext) && isFilter "/>
        <!-- [ZONE] 필터 영역 -->
        <div class="ur-data-grid__header__context__filter" v-if="isFilter">
            <!-- 이거 컴포넌트로 뺐으면 좋겠는데, 코드가 난잡하다. -->
            <template v-if="filterCase==='STRING'">
                <div class="ur-data-grid__header__context__filter-row">
                    <!-- XXX Need select all -->
                    <grid-text-field v-model="str" ref="stringInput"
                        @keyup.enter="searchData(true)"
                        @keyup.esc="resetContext"
                        placeholder="Text for filter"/>
                </div>
            </template>
            <template v-else-if="filterCase==='STRING-DOMAIN'">
                <div class="ur-data-grid__header__context__filter-row" v-for="dom in ctxField.domain">
                    <!-- TODO Select all -->
                    <ur-checkbox sm v-model="arr" :value="dom" @input="searchData">{{dom}}</ur-checkbox>
                </div>
            </template>
            <template v-else-if="filterCase==='CODE-DOMAIN' && isDomainMap">
                <!-- Same as STRING-DOMAIN? -->
                <div class="ur-data-grid__header__context__filter-row" v-for="dom in ctxField.domain">
                    <ur-checkbox sm v-model="arr" :value="dom.value" @input="searchData">{{dom.text}}</ur-checkbox>
                </div>
            </template>
            <template v-else-if="filterCase==='CODE-DOMAIN' && !isDomainMap">
                <!-- Same as STRING-DOMAIN? -->
                <div class="ur-data-grid__header__context__filter-row" v-for="dom in ctxField.domain">
                    <ur-checkbox sm v-model="arr" :value="dom" @input="searchData">{{dom}}</ur-checkbox>
                </div>
            </template>
            <template v-else-if="filterCase==='NUMBER'">
                <div class="ur-data-grid__header__context__filter-row ur-data-grid__header__context__filter-row__num-single">
                    <grid-stepper v-model="n1" addsub
                        @num:clicked="searchData" @keyup.enter="searchData(true)" @keyup.esc="resetContext"
                        placeholder="Equal to #"/>
                </div>
            </template>
            <template v-else-if="filterCase==='NUMBER-RANGE'">
                <div class="ur-data-grid__header__context__filter-row ur-data-grid__header__context__filter-row--ranged-num">
                    <grid-stepper v-model="n1" :max="n2||Infinity"
                        @num:clicked="searchData" @keyup.enter="searchData(true)" @keyup.esc="resetContext"
                        placeholder="Lower #"/>
                    <label class="ur-data-grid__header__context__filter-row__divider">~</label>
                    <grid-stepper v-model="n2" :min="n1||-Infinity"
                        @num:clicked="searchData" @keyup.enter="searchData(true)" @keyup.esc="resetContext"
                        placeholder="Upper #"/>
                </div>
            </template>
            <template v-else-if="filterCase==='DATE'">
                <div class="ur-data-grid__header__context__filter-row
                            ur-data-grid__header__context__filter-row--single-date">
                    <grid-date-picker v-model="date" :date-format="dFormat" :timezone="timezone"
                            @keyup.enter="searchData(true)" @picker:confirm="searchData(true)"/>
                    
                </div>
            </template>
            <template v-else-if="filterCase==='DATE-RANGE'">
                <div class="ur-data-grid__header__context__filter-row
                            ur-data-grid__header__context__filter-row--ranged-date">
                    <grid-date-picker v-model="d1" :max-date="d2" :date-format="dFormat"
                            @keyup.enter="searchData(false)" @picker:confirm="searchData(false)"/>
                    <label class="ur-data-grid__header__context__filter-row__divider">~</label>
                    <grid-date-picker v-model="d2" :min-date="d1" :date-format="dFormat"
                            @keyup.enter="searchData(false)" @picker:confirm="searchData(false)"/>
                </div>
            </template>
            <template v-else-if="filterCase==='FLAG'">
                <div class="ur-data-grid__header__context__filter-row">
                    <ur-checkbox sm v-model="arr" :value="0" @input="searchData">false</ur-checkbox>
                </div>
                <div class="ur-data-grid__header__context__filter-row">
                    <ur-checkbox sm v-model="arr" :value="1" @input="searchData">true</ur-checkbox>
                </div>
            </template>
            <div class="ur-data-grid__header__context__action-row">
                <ur-button @click="clearValue" small>Clear</ur-button>
                <ur-button @click="searchValue" main small>Search</ur-button>
            </div>
        </div>
    </div>
</template>

<script>

import gridTextField  from "../../edit/urDataGridEditTextField.vue";
import gridStepper    from "../../edit/urDataGridEditStepper.vue";
import gridDatePicker from "../../edit/urDataGridEditDatePicker.vue";
import {copyArr}      from "../../util";

export default {
    name : 'urDataGridHeaderContext',
    inject : ['gridInfo'],
    components: {gridTextField, gridStepper,gridDatePicker},
    data() {return {
        str:"", arr:[],
        n1:null, n2:null,
        date:null,
        d1:null, d2:null,
        fetching : false
    }},
    beforeUpdate() {this.fetching = true}, // avoid init change event
    updated()      {this.fetching = false},
    computed : {
        // [COMPUTED] Value, timezone
        timezone() {return this.ctxField.timezone === null ? this.gridInfo.opts.timezone : this.ctxField.timezone},
        ctxField() {return this.gridInfo.vars_headerContext || {}},
        ctxStyle() {
            var style = {};
            style['left'] = this.ctxField.__posLeft+'px';
            return style;
        },
        isCtxOpen(){return !!this.gridInfo.vars_headerContext},
        isSort()   {return this.ctxField.__isSort},
        isFilter() {return this.ctxField.__isFilter},
        isContext(){return this.ctxField.headerContext},
        isSortAsc(){return this.ctxField.__sortOrder === 'A'},
        isSortDes(){return this.ctxField.__sortOrder === 'D'},
        
        isDomainMap() {return !!this.ctxField.__domainMap},
        
        filterCase() {
            if(this.ctxField.type === 'string') {
                if(Array.isArray(this.ctxField.domain)) {
                    return 'STRING-DOMAIN'
                }
            } else if(this.ctxField.type === 'number') {
                if(this.ctxField.checker === 'numberRange') {
                    return 'NUMBER-RANGE'
                }
                return 'NUMBER';
            } else if(this.ctxField.type === 'code') {
                if(Array.isArray(this.ctxField.domain)) {
                    return 'CODE-DOMAIN'
                }
            } else if(this.ctxField.type === 'date') {
                if(this.ctxField.checker === 'dateRange') {
                    return 'DATE-RANGE'
                }
                return 'DATE'
            } else if(this.ctxField.type === 'boolean') {
                return 'FLAG'
            }
            // for default case
            return 'STRING';// why CAPITAL?
        },
        dFormat() {return this.gridInfo.opts.dateFormat},
        msgAsc() {return this.gridInfo.opts.msgAscending},
        msgDes() {return this.gridInfo.opts.msgDescending},
        customContexts() {
            var ctxs = this.ctxField.headerContext
            if(typeof ctxs === 'function') {
                return ctxs(this.ctxField);
            } else if(Array.isArray(ctxs)){
                return ctxs;
            } else {
                // else? We didn't expect that type value.
                return [];
            }
        }
    },
    watch : {
        'gridInfo.vars_headerContext': {immediate: true, handler(v) {
            // set init value
            this.initFilterValue();
        }}
    },
    methods : {
        setSort(dir) {
            if(dir === this.ctxField.__sortOrder) {
                this.gridInfo.func.toggleSortField(this.ctxField, '')
            } else {
                this.gridInfo.func.toggleSortField(this.ctxField, dir)
            }
            this.resetContext();
        },
        searchData(isClose) {
            if(this.fetching) return;
            // 1. set value to ctxField
            this.ctxField.__filterValue = this.getFilterValue();
            // 2. make filter array & filter data
            var arr = this.gridInfo.func.buildFilter();
            if(!this.gridInfo.opts.externalFilter) {
                this.gridInfo.func.buildData();
            }
            // 3. fire event
            this.gridInfo.func.fireEvent('filtered',copyArr(arr));
            // 4. check flag & close
            if(isClose===true) {this.resetContext()}
        },
        resetContext() {
            this.gridInfo.func.setHeaderContext(null);
        },
        initFilterValue() {
            var f = this.ctxField.__filterValue;
            // 1. check something
            switch(this.filterCase) {
            case "STRING":
                this.str=f;
                break;
            case "NUMBER":this.n1=f      ;break;
            case "DATE"  :this.date=f||'';break;
            case "FLAG"         :
            case "CODE-DOMAIN"  :
            case "STRING-DOMAIN":
                this.arr=f||[];break;
            case "NUMBER-RANGE":
                this.n1=f?f[0]:NaN;
                this.n2=f?f[1]:NaN;
                break;
            case "DATE-RANGE":
                this.d1=f?f[0]:null;
                this.d2=f?f[1]:null;
                break;
            }
        },
        getFilterValue() {
            switch(this.filterCase) {
            case "STRING"      : return this.str;
            case "NUMBER"      : return this.n1;
            case "NUMBER-RANGE": return [this.n1, this.n2];
            case "DATE"        : return this.date;
            case "DATE-RANGE"  : return [this.d1, this.d2];
            case "FLAG"         :
            case "CODE-DOMAIN"  :
            case "STRING-DOMAIN":
                return this.arr;
            }
            return null;
        },
        clearValue() {
            // 1. clear data
            switch(this.filterCase) {
            case "STRING":this.str='';break;
            case "NUMBER":this.n1=null;break;
            case "DATE"  :this.date=null;break;
            case "FLAG"         :
            case "CODE-DOMAIN"  :
            case "STRING-DOMAIN":
                this.arr=[];break;
            case "NUMBER-RANGE":
                this.n1=NaN;
                this.n2=NaN;
                break;
            case "DATE-RANGE":
                this.d1=null;
                this.d2=null;
                break;
            }
            // 2. search value 
            this.searchData();
        },
        searchValue() {
            // 2. search value 
            this.searchData(true);
        },
        preventOverflow(el) {
                var pl = el.parentElement;
                var eRect = el.getBoundingClientRect();
                var pRect = pl.getBoundingClientRect();
                if(eRect.right > pRect.right) {
                    this.gridInfo.vars_headerContext.__posLeft -= eRect.right - pRect.right;
                } else if (eRect.left < pRect.left) {
                    this.gridInfo.vars_headerContext.__posLeft = 0;
                }
        },
        onClickContext(ctx) {
            if(typeof ctx.action === 'function') {
                ctx.action(this.ctxField); // not reactive...
            } else if(typeof ctx.action === 'string'){
                this.gridInfo.func.fireEvent('context:'+ctx.action, this.ctxField);
            }
            this.resetContext();
        }
    },
    directives: {
        'towardCenter': {
            inserted: function(el, {value}) {
                if(typeof value ==="function") value(el);
            },
            update  : function(el, {value}) {
                if(typeof value ==="function") value(el);
            },
        }
    } /**/
}
</script>